export default __webpack_public_path__ + "static/media/email-envelope.2c89b0e9.svg";